// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1_GFl","filesListContainer":"PosDisputesFiles_filesListContainer__10ZoX","filesButton":"PosDisputesFiles_filesButton__2Fi_q"};